import type { WorkerSchema } from '../types'

/** UI schema for unmatched slips (client-side data, not an API worker). */
export const BillLinReceivableSlipSchema: WorkerSchema = {
  workerId: 'bill-lin-receivable-slip',
  workerLabel: 'สลิปค้าง',
  tabIcon: 'receipt',
  recordPrefix: 'SL',
  apiEndpoint: '',
  defaultSort: { col: 'created_at', dir: 'desc' },
  searchFields: ['slip_sender', 'slip_ref', 'bank'],

  columns: [
    {
      id: 'created_at',
      header: 'วันที่',
      type: 'datetime',
      editable: false,
      sortable: true,
      visibility: 'always',
      width: 150,
    },
    {
      id: 'transfer_date',
      header: 'วันเวลาโอน',
      type: 'datetime',
      editable: false,
      sortable: true,
      visibility: 'hidden',
      width: 150,
    },
    {
      id: 'slip_sender',
      header: 'ผู้โอน',
      type: 'text',
      editable: false,
      visibility: 'always',
    },
    {
      id: 'amount_original',
      header: 'ยอดโอน',
      type: 'amount',
      editable: false,
      sortable: true,
      visibility: 'always',
      align: 'right',
    },
    {
      id: 'amount_allocated',
      header: 'จับคู่แล้ว',
      type: 'amount',
      editable: false,
      sortable: true,
      visibility: 'always',
      align: 'right',
    },
    {
      id: 'slip_amount',
      header: 'รอจัดสรร',
      type: 'amount',
      editable: false,
      sortable: true,
      visibility: 'always',
      align: 'right',
    },
    {
      id: '__status__',
      header: 'สถานะ',
      type: 'status',
      editable: false,
      visibility: 'always',
    },
    // Drawer / detail only — table ends at สถานะ (plan §1.4)
    {
      id: 'slip_image',
      header: 'สลิป',
      type: 'image',
      editable: false,
      visibility: 'hidden',
      width: 70,
    },
    {
      id: 'bank',
      header: 'ธนาคาร',
      type: 'bank',
      editable: false,
      visibility: 'hidden',
    },
    {
      id: 'slip_ref',
      header: 'อ้างอิง',
      type: 'text',
      editable: false,
      visibility: 'hidden',
    },
    {
      id: 'expires_at',
      header: 'หมดอายุใน',
      type: 'text',
      editable: false,
      sortable: true,
      visibility: 'hidden',
      width: 168,
    },
  ],

  drawerSections: [
    {
      label: 'PAYMENT',
      fields: [
        'transfer_date',
        'transfer_datetime',
        'amount_original',
        'amount_allocated',
        'slip_amount',
        'slip_ref',
        'slip_image',
        'bank',
        'slip_sender',
        'sender_bank',
        'sender_name',
        'reference_no',
      ],
    },
    {
      label: 'DETAILS',
      fields: [
        'created_at',
        'expires_at',
        'queue_left_at',
        'queue_left_reason',
        'updated_at',
        'recorded_at',
        'record_date',
        'slip_date',
        'payment_date',
        'remark',
      ],
    },
  ],

  filterOptions: {
    status: ['ค้าง', 'รอตรวจ', 'เหลือรอจัดสรร', 'รายการที่ลบ', 'หมดอายุ'],
    datePresets: [
      'วันนี้',
      '7 วันที่ผ่านมา',
      'เดือนนี้',
      'เดือนที่แล้ว',
      'กำหนดเอง',
    ],
  },

  emptyState: {
    icon: '🧾',
    title: 'ไม่มีสลิปค้าง',
    body: 'เปิดแชตบิลลินในไลน์เพื่อจัดการสลิปที่รอจับคู่และปิดยอดได้เลยครับ',
  },
}
